<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">

                    <v-col lg="3" md="3" cols="12">
                      <v-autocomplete
                        label="Approval Name"
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="approval_name_id.value.value"
                        :error-messages="approval_name_id.errorMessage.value"
                        item-value="id"
                        :items="getApprovalNameList"
                        :item-title="item => `${item.name}`"   
                        autocomplete="off"                                               
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Approval Matrix List</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        @click="goTo('/administration/approval-setup')"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi mdi-plus"
                        rounded="xl"
                        size="small"
                        width="100%"
                      >
                        Create Approval Matrix
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                  show-expand
                  item-key="id"
                  class="elevation-1"
                >
                    <template v-slot:item.index="{ index }">
                        {{ ++index }}
                    </template>

                  <template v-slot:item.approved_ind ="{ item }">
                    <v-chip
                      v-if="item.approved_ind == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Yes</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >No</v-chip
                    >
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      class="me-2 edit-button"
                      color="primary"
                      @click="editItem(item)"
                      v-if="$updateAccess($route.fullPath)"
                    >
                      mdi mdi-pencil-outline
                    </v-icon>
                  </template>
                  <template v-slot:expanded-row="{ item, columns }">
                    <tr>
                        <td :colspan="columns.length">
                            <v-card flat class="ma-2 pa-2 rounded" color="grey-lighten-4">
                                <div class="text-subtitle-2 text-center text-decoration-underline mb-2">Approval Steps</div>
                                <v-data-table
                                    :headers="detailHeaders"
                                    :items="item.details"
                                    density="compact"
                                    class="elevation-1 pa-2 rounded"
                                    show-expand
                                    hide-default-footer
                                >
                                <!-- Sl -->
                                <template v-slot:item.sl="{ item }">
                                    {{ item.sl }}
                                </template>
        
                                <!-- Step Name -->
                                <template v-slot:item.approval_step_name="{ item }">
                                    <v-chip color="purple-lighten-1" size="small">{{ item.approval_step_name?.name }}</v-chip>
                                </template>
        
                               
                                <template v-slot:item.approvers="{ item }">
                                    {{ item.approvers.map(item => item.employee.name) }}
                                </template>
                                
                                <template v-slot:item.can_edit="{ item }">
                                    <v-chip
                                        :color="item.can_edit == 1 ? 'success' : 'grey'"
                                        size="small"
                                        variant="flat"
                                    >
                                        {{ item.can_edit == 1 ? 'Yes' : 'No' }}
                                    </v-chip>
                                </template>

                                <template v-slot:item.has_review="{ item }">
                                    <v-chip
                                        :color="item.has_review == 1 ? 'success' : 'grey'"
                                        size="small"
                                        variant="flat"
                                    >
                                        {{ item.has_review == 1 ? 'Yes' : 'No' }}
                                    </v-chip>
                                </template>
        
                                <!-- Final Step -->
                                <template v-slot:item.is_final_step="{ item }">
                                    <v-chip
                                        :color="item.is_final_step == 1 ? 'success' : 'grey'"
                                        size="small"
                                        variant="flat"
                                    >
                                        {{ item.is_final_step == 1 ? 'Yes' : 'No' }}
                                    </v-chip>
                                </template>

                                <template v-slot:expanded-row="{ item, columns }">
                                  <tr>
                                      <td :colspan="columns.length">
                                        <v-card flat class="ma-2" color="grey-darken-4">
                                            <v-data-table
                                                :headers="detailReviewHeaders"
                                                :items="item.review_matrix_details"
                                                density="compact"
                                                class="elevation-1 pa-2 rounded"
                                                hide-default-footer
                                            >
                                            <template v-slot:item.srl="{ item }">
                                                {{ item.srl }}
                                            </template>

                                             <template v-slot:item.employee="{ item }">
                                                {{ item.employee?.name }}
                                            </template>
                                            
                                            <template v-slot:item.can_edit="{ item }">
                                                <v-chip
                                                    :color="item.can_edit == 1 ? 'success' : 'grey'"
                                                    size="small"
                                                    variant="flat"
                                                >
                                                    {{ item.can_edit == 1 ? 'Yes' : 'No' }}
                                                </v-chip>
                                            </template>

                                            </v-data-table>
                                          </v-card>
                                        </td>
                                    </tr>
                                  </template>
                            </v-data-table>
                            </v-card>
                        </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import formattedDate from "@/plugins/dateFormatter";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false,},
      { title: "Code", align: "center", key: "code", sortable: false,},
      { title: "Approval Flow", key: "approval_name.name", align: "center", sortable: false },
      { title: "Total Person", key: "total_person", align: "left", sortable: true,},
      { title: "Remarks", key: "remarks", align: "left", sortable: false,},
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
    detailHeaders: [
      { title: 'SL', align: "center", key: 'sl', width: "7%",},
      { title: 'Approvers', align: "center", key: 'approvers' },
      { title: 'Can Edit', align: "center", key: 'can_edit' },
      { title: 'Has Review', align: "center", key: 'has_review' },
      { title: 'Final Step', align: "center", key: 'is_final_step' }
    ],
    detailReviewHeaders: [
      { title: 'SL', align: "center", key: 'srl', width: "7%",},
      { title: 'User', align: "center", key: 'employee' },
      { title: 'Can Edit', align: "center", key: 'can_edit' }
    ],
  }),
  watch: {},
  created() {
    if(this.$store.getters.getApprovalNameList.length == 0){
        this.$store.dispatch('getApprovalNameList');
    };
  },
  computed: {
    getSchema() {
      return this.$store.getters.getApprovalMatrixList || [];
    },
    getApprovalNameList() {
        let data = this.$store.getters.getApprovalNameList;
        if(data.length > 0){
            return data.filter((item) => item.status == 1);
        }
        return [];
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        approval_name_id: yup.number().positive().integer().nullable().label('Approval Name'),
        // from_date: yup.date().required().label('Requisition Date'),
        // supplier_id: yup.number().positive().integer().nullable().label('supplier Name'),
        // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),
      }),
    });

    const approval_name_id = useField("approval_name_id");
    // const from_date = useField("from_date");
    // const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
        loading.value = true;
        store.dispatch("getApprovalMatrixList", values).then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });

    return {
      submit,
      approval_name_id,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      // this.$store.commit('setEditingRequisition', item);
      this.$router.push({
        name: "approval-setup",
        query: { id: item.id },
      });
      // this.data = { ...item };
      // this.dialog = true;
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Code",
        "supplier",
        "Warehouse",  
        "Amount",
        "Approval Status",
        "Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.supplier.name,
        item.warehouse.name,
        item.amount,
        item.approved_ind === 1 ? "YES": "NO",
        item.status == 1 ? "POST" : "DRAFT",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Approval Matrix List",
        "direct_receive_list" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "Code",
          "supplier",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.supplier.name,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES": "NO",
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });
      this.$exportTableToExcel(data, "direct_receive_list" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "Code",
          "supplier",
          "Warehouse",
          "Amount",
          "Approval Status",
          "Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.supplier.name,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES": "NO",
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });

      this.$exportTableToCSV(data, "direct_receive_list" + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });
  },
};
</script>
